"use client";

import { agentsFiltersAtom } from "@/app/(saas)/(app)/business-brokers/_components/filters/state";
import { useAtom } from "jotai";
import { useMemo } from "react";

export function AgentListClearFilters() {
  const [filters, setFilters] = useAtom(agentsFiltersAtom);

  const hasFilters = useMemo(() => {
    return (
      (!!filters.name && filters.location) ||
      filters.languageIds.length > 0 ||
      filters.specialtyIds.length > 0
    );
  }, [filters]);

  function handleClearFilters() {
    setFilters((prev) => ({
      ...prev,
      name: prev.location ? null : prev.name,
      languageIds: [],
      specialtyIds: [],
    }));
  }

  if (!hasFilters) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleClearFilters}
      className="text-sm text-[var(--venturu-gray-500)] hover:text-[var(--venturu-black)] transition-colors underline underline-offset-2"
    >
      Clear all
    </button>
  );
}

AgentListClearFilters.displayName = "AgentListClearFilters";
